module.exports = __webpack_public_path__ + "img/Pista_36.708e3ef9.png";